import React from "react";
import getTranslations from "../../../i18n";
import { Router } from "react-router";
import { hydrate } from "react-dom";
import App from "../../containers/App";
import routes from "../../routes";
import { getLocale } from "../../state/modules/config/selectors";
import setupRouteChangeListener from "../setupRouteChangeListener";
import loadDynamicComponents from "./loadDynamicComponents";

const bootstrapReact = async store => {
  const history = setupRouteChangeListener(store);

  const [translations] = await Promise.all([
    getTranslations(getLocale(store.getState())),
    loadDynamicComponents()
  ]);

  hydrate(
    <App
      store={store}
      translations={translations}
      RouterComponent={Router}
      history={history}
      routes={routes}
    />,
    document.getElementById("plp")
  );
};

export default bootstrapReact;
